import type { AdminTaxInvoiceRecord } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { TAX_INVOICE_KIND_LABELS, TAX_INVOICE_STATUS_LABELS } from '@/entities/tax-invoice';
import { formatDateTime, formatWon } from '@/shared/lib';

export const TaxInvoiceRecordRow = ({
  record,
}: {
  readonly record: AdminTaxInvoiceRecord;
}): ReactElement => (
  <div className="rounded-lg border p-3 text-sm space-y-1">
    <p>
      {TAX_INVOICE_KIND_LABELS[record.kind]} · {TAX_INVOICE_STATUS_LABELS[record.status]}
    </p>
    <p>문서번호: {record.mgtKey}</p>
    <p>작성일: {record.writeDate}</p>
    <p>
      공급가액: {formatWon(record.supplyAmount)} · 부가세: {formatWon(record.vatAmount)} · 합계:{' '}
      {formatWon(record.totalAmount)}
    </p>
    <p>승인번호: {record.ntsConfirmNum ?? '-'}</p>
    <p>발행일: {record.issuedAt ? formatDateTime(record.issuedAt) : '-'}</p>
    <p>시도: {record.attempts}회</p>
    {record.failureMessage ? <p>실패 사유: {record.failureMessage}</p> : null}
  </div>
);
